import { queryOptions } from "@tanstack/react-query";
import { getOrganizations } from "./organizations";
import { getPositions } from "./positions";
import { listInvites, getInvitePreview } from "./invites";

export function organizationsQueryOptions(
  getToken: () => Promise<string | null>,
) {
  return queryOptions({
    queryKey: ["organizations"],
    queryFn: () => getOrganizations(getToken),
  });
}

export function positionsQueryOptions(
  getToken: () => Promise<string | null>,
  orgId: string,
) {
  return queryOptions({
    queryKey: ["positions", orgId],
    queryFn: () => getPositions(getToken, orgId),
  });
}

export function invitesQueryOptions(
  getToken: () => Promise<string | null>,
  orgId: string,
) {
  return queryOptions({
    queryKey: ["invites", orgId],
    queryFn: () => listInvites(getToken, orgId),
  });
}

export function invitePreviewQueryOptions(
  getToken: () => Promise<string | null>,
  code: string,
) {
  return queryOptions({
    queryKey: ["invitePreview", code],
    queryFn: () => getInvitePreview(getToken, code),
    enabled: !!code,
    retry: false,
  });
}
